<template>
    <section class="testimonials">
        <div class="wrapper">
            <h2 class="titre">Ils racontent l'expérience grands espaces</h2>
            <div class="testimonial-wrap"
                 v-touch:swipe.right="goPrevItem"
                 v-touch:swipe.left="goNextItem"
            >

                <div class="wrap-note" v-if="!isMobile">
                    <p class="note"><span v-html="selectedItem.note"></span>/5</p>
                    <p class="etoiles">

                        <img
                                v-for="n in selectedItem.note"
                                :src="fullStar"
                                alt=""><img
                            v-for="n in emptyStars"
                            :src="emptyStar"
                            alt="">

                    </p>
                </div>
                <div class="wrap-text-auteur">
                    <div class="wrap-text">
                    <transition :name="transitionName" mode="out-in" @after-leave="updateheight()">
                        <p class="text"
                           v-for="(item, index) in items"
                           v-html="formatText(item.text)"
                           v-if="isActive(index)"
                           :key="index"
                        ></p>
                    </transition>
                    </div>

                    <div class="nav-mobile" v-if="isMobile">
                        <div class="btn-prev" @click="goPrevItem()" :class="{disabled: reachStart}"></div>
                        <div class="wrap-note">
                            <p class="note"><span v-html="selectedItem.note"></span>/5</p>
                            <p class="etoiles">

                                <img
                                        v-for="n in selectedItem.note"
                                        :src="fullStar"
                                        alt=""><img
                                    v-for="n in emptyStars"
                                    :src="emptyStar"
                                    alt="">

                            </p>
                        </div>
                        <div class="btn-next" @click="goNextItem()" :class="{disabled: reachEnd}"></div>
                    </div>
                    <div class="bar"></div>
                    <div class="footer">
                        <div class="bloc-auteur">
                            <transition :name="transitionName" mode="out-in">
                                <p class="auteur"
                                   v-for="(item, index) in items"
                                   v-html="item.auteur"
                                   v-if="isActive(index)"
                                   :key="index"
                                ></p>
                            </transition>
                            <transition :name="transitionName" mode="out-in">
                                <p class="croisiere"
                                   v-for="(item, index) in items"
                                   v-if="isActive(index)"
                                   :key="index"
                                ><span>⏤  </span>{{item.cruisename}}</p>
                            </transition>

                        </div>
                        <div class="bloc-arrows" v-if="!isMobile">
                            <div class="btn-prev" @click="goPrevItem()" :class="{disabled: reachStart}"></div>
                            <div class="btn-next" @click="goNextItem()" :class="{disabled: reachEnd}"></div>
                        </div>
                    </div>
                </div>

                <slot></slot>

            </div>
        </div>
    </section>
</template>

<script>

    import {breakpointDown} from '../../libs/Breakpoints';
    import {debounce} from 'lodash'

    import $ from 'jquery';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                selectedItem: null,
                activeIndex: 0,
                isMobile: false,
                transitionName: 'slide-right'
            };
        },
        watch: {
            activeIndex(newIndex, oldIndex) {
                this.selectedItem = this.items[newIndex];
            },
        },
        computed: {
            fullStar() {
                return window.GrandsEspaces.card_stars_full;
            },
            emptyStar() {
                return window.GrandsEspaces.card_stars_empty;
            },
            emptyStars() {
                return 5 - this.selectedItem.note;
            },
            reachStart() {
                return this.activeIndex === 0;
            },
            reachEnd() {
                return this.activeIndex === this.items.length - 1;
            }
        },
        methods: {
            formatText(value) {
                return '« ' + value + ' »';
            },
            isActive(index) {
                return index === this.activeIndex;
            },
            goPrevItem() {
                if (!this.reachStart) {
                    this.transitionName = 'slide-left';
                    this.activeIndex = this.activeIndex - 1;
                }
            },
            goNextItem() {
                if (!this.reachEnd) {
                    this.transitionName = 'slide-right';
                    this.activeIndex = this.activeIndex + 1;
                }
            },
            updateheight: debounce(function(){
                $('.wrap-text-auteur .wrap-text').css('height', $('.wrap-text-auteur .text').height()+'px')

            },10)
        },
        created() {
            this.selectedItem = this.items[this.activeIndex];
        },
        mounted() {
            this.updateheight()
            $(window).bind('resizeEnd', () => {
                this.isMobile = breakpointDown('md');
            });
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/home-page/Testimonials.vue